goog.provide("shadow.js.shim.module$react_window");
goog.provide("module$shadow_js_shim_module$react_window");
shadow.js.shim.module$react_window = shadow.js.nativeProvides["react-window"] = shadow$bridge("react-window");
module$shadow_js_shim_module$react_window.default = shadow.js.shim.module$react_window;
